module.exports = __webpack_public_path__ + "static/media/collapseall.dde92a72.svg";